const AUTH_STORAGE_KEY = 'authData';

export const getAuthData = () =>
  JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY) || '{}');

export const hasAuthData = () => !!getAuthData().userId;

export const saveAuthData = ({ userId, userName, accessToken }) =>
  localStorage.setItem(
    AUTH_STORAGE_KEY,
    JSON.stringify({ userId, userName, accessToken })
  );

export const clearAuthData = () => localStorage.removeItem(AUTH_STORAGE_KEY);

/**
 * Get data saved in token (userId, role..)
 * @returns {object|null}
 */
export const getTokenData = () => {
  const { accessToken } = getAuthData();

  if (!accessToken) {
    return null;
  }

  try {
    const token = accessToken.startsWith('Bearer ')
      ? accessToken.slice(7)
      : accessToken;
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad === 2) base64 += '==';
    else if (pad === 3) base64 += '=';
    else if (pad === 1) base64 += '===';

    const json = atob(base64);
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};
